/* eslint-disable react/react-in-jsx-scope */
// import * as React from 'react';
import { useState, useEffect, useMemo, useRef, useCallback } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router'
import { useUserContext, useUserDispatch } from '../../contexts/UserContext';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
    DataGrid,
    gridClasses,
    GridColDef,
    GridToolbarQuickFilter,
    gridPageCountSelector,
    GridPagination,
    useGridApiContext,
    useGridSelector,
  } from '@mui/x-data-grid';
  import MuiPagination from '@mui/material/Pagination';
  import { PrinterIcon  } from '@heroicons/react/24/outline'
  import useComponentVisible from '../../components/useComponentVisible'
  import InvoicesActions from '../../components/dataTable/InvoicesActions';

    // function CustomToolbar() {
    //     return (
    //         <GridToolbarContainer>
    //         <GridToolbarColumnsButton />
    //         <GridToolbarFilterButton />
    //         <GridToolbarDensitySelector />
    //         <GridToolbarExport />
    //         </GridToolbarContainer>
    //     );
    // }

    // function currencyFormat(num) {
    //     return parseFloat(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '1,') + '฿';
    //   }

      function numberWithCommas (nStr) {
        nStr = nStr + '';
          let x = nStr.split('.');
          let x1 = x[0];
          let x2 = x.length > 1 ? '.' + x[1] : '';
          var rgx = /(\d+)(\d{3})/;
          while (rgx.test(x1)) {
              x1 = x1.replace(rgx, '$1' + ',' + '$2');
          }
          x = x1 + x2;
          if(x.substr(0,1) === '.'){
              x = '0' + x;
          }
          return x + '฿';
      };
  
export default function Invoices() {
    const navigate = useNavigate();
    const user = useUserContext();
    // const dispatch = useUserDispatch();
    const [data, setData] = useState([]);
    const [detail, setDetail] = useState([]);
    const [inv, setInv] = useState([]);
    const [ filterData, setFilterData] = useState();
    const [rowId, setRowId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const {
        ref,
        isComponentVisible,
        setIsComponentVisible
      } = useComponentVisible(false);
    const [totalRow, settotalRow] = useState(0);
    // const [page, setPage] = useState(0);
    // const [itemsPage, setitemsPage] = useState(10);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 100,
      });

    const [rowCount ,setRowCount] = useState({
        rowCount: totalRow,
    })
    //   const rowCountRef = useRef(pageInfo?.totalRowCount || 0);

    //   const rowCount = React.useMemo(() => {
    //     if (pageInfo?.totalRowCount !== undefined) {
    //       rowCountRef.current = pageInfo.totalRowCount;
    //     }
    //     return rowCountRef.current;
    //   }, [pageInfo?.totalRowCount]);

    const [totalPages, settotalPages] = useState(0);
    const apiurl = `${process.env.REACT_APP_API}`;
    const webpath = '/pos/invoices'

    const handleClick = {

    }

    const columns= useMemo(() => [
        { field: 'InvNo', headerName: 'InvNo', minWidth: 100 },
        {
            field: 'date',
            headerName: 'Date',
            width: 150,
            editable: false,
            flex: 1,
            minWidth:150,
        },
        {
            field: 'cashier',
            headerName: 'Cashier',
            // width: 90,
            editable: false,
            // flex: 1,
            minWidth:120,

        },
        {
            field: 'customer_id',
            headerName: 'Customer',
            // renderHeader: (params: GridColumnHeaderParams) => (
            //     <strong>
            //       {'Birthday '}
            //       <span role="img" aria-label="enjoy">
            //         🎂
            //       </span>
            //     </strong>
            //   ),
            // width: 150,
            editable: false,
            // flex: 1,
            minWidth:120,

        },
        {
            field: 'paidtype',
            headerName: 'PaidType',
            width: 120,
            editable: false,
        },
        {
            field: 'subtotal',
            headerName: 'SubTotal',
            type: 'number',
            width: 130,
            editable: false,
        },
        {
            field: 'discount',
            headerName: 'Discount',
            type: 'number',
            width: 120,
            editable: false,
        },
        {
            field: 'vat',
            headerName: 'Vat',
            type: 'number',
            width: 100,
            editable: false,
        },
        {
            field: 'total',
            headerName: 'Total',
            type: 'number',
            width: 120,
            editable: false,
            // flex: 1,
        },
        {
            field: 'actions',
            headerName: 'Actions',
            type: 'actions',
            renderCell: params => <InvoicesActions {...{params, rowId, setRowId, data, setData, webpath}} />,
            // headerClassName: 'datatable-header',
            headerAlign: 'center',
            width: 150,
            editable: false,
            // flex: 1,
        },
    ],[rowId]);

    const columnsDetail: GridColDef[] = [
        { field: 'InvNo', headerName: 'InvNo', width: 60, hide: true },
        {
            field: 'ItemNo',
            headerName: 'ItemNo',
            width: 60,
            editable: false,
        },
        {
            field: 'prodId',
            headerName: 'ProdId',
            width: 60,
            editable: false,
        },
        {
            field: 'prodName',
            headerName: 'ProdName',
            width: 150,
            editable: false,
            flex: 1,
        },
        {
            field: 'qty',
            headerName: 'Qty',
            type: 'number',
            width: 60,
            editable: true,
        },
        {
            field: 'price',
            headerName: 'Price',
            type: 'number',
            width: 80,
            editable: false,
        },
        {
            field: 'total',
            headerName: 'Total',
            type: 'number',
            // description: 'This column has a value getter and is not sortable.',
            sortable: false,
            width: 120,
            valueGetter: (value, row) => `${row.qty * row.price }`,
            flex: 1,
        },
    ];

    //list invoice
    const fetchInvoices = async () => {
        setLoading(true);
        try {
        //   const result = await axios.get(`${apiurl}/invoice.php?mode=list`);
          const result = await axios.get(`${apiurl}/invoice.php`, {
            params: {
              mode: 'list',
              itemsPerPage: paginationModel.pageSize,
              page: paginationModel.page,
            },
          });
        //   console.log(result);
          // console.log(result.data);
          // if(result.data.length>0) {
          if(result.data && result.data[0].length>0) {  
            // const data = await response.json();
            // console.log(result.data[0]);
            setData(result.data[0]);
            settotalRow(result.data.rowTotal);
            settotalPages(result.data.totalPages);
            setLoading(false);
            return result.data[0];
          } else {
            console.log(result);
            setLoading(false);
          }
  
        }
        catch(err) {
            console.log(err);
            setLoading(false);
        }
    }

        //list invoice
        const fetchInvDetail = async (invid) => {
            setLoading2(true);

            try {
              const result = await axios.get(`${apiurl}/invoice.php?mode=getdetail&id=${invid}`);
              
            //   console.log(result);
              // console.log(result.data);
              // if(result.data.length>0) {
              if(result.data && result.data[0].length>0) {  
                // const data = await response.json();
                // console.log(result.data[0]);
                setDetail(result.data[0]);
                setLoading2(false);
                return result.data[0];
              } else {
                console.log(result);
                setLoading2(false);
              }
      
            }
            catch(err) {
                console.log(err);
                setDetail([]);
                setLoading2(false);
            }
        }
  
    useEffect(() => {
      if(user?.user?.isAdmin < 1 ) {  // Role !== 'Admin'
        navigate("/")
      }}) 
      
    useEffect(() => {
  
        fetchInvoices();
      
    },[paginationModel])


    const handleCellClick = (e) => {
        // console.log(e);
        setInv(e.row);

        fetchInvDetail(e.id);
    }

    const handlePrintClick = () => {
        //
        const bodyElement = document.getElementsByTagName('body')[0];

        bodyElement.classList.add('printing');
        window.print();
        bodyElement.classList.remove('printing');
    }

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
      }
    
      function QuickSearchToolbar() {
        return (
          <Box
            sx={{
              p: 0.5,
              pb: 0,
            }}
          >
            <GridToolbarQuickFilter
              quickFilterParser={(searchInput) =>
                searchInput
                  .split(',')
                  .map((value) => value.trim())
                  .filter((value) => value !== '')
              }
            />
          </Box>
        );
      }

    function Pagination({ page, onPageChange, className }) {
        const apiRef = useGridApiContext();
        const pageCount = useGridSelector(apiRef, gridPageCountSelector);

        return (
            <MuiPagination
            color="primary"
            className={className}
            count={pageCount}
            page={page + 1}
            onChange={(event, newPage) => {
                onPageChange(event, newPage - 1);
            }}
            />
        );
    }

    function CustomPagination(props) {
        return <GridPagination ActionsComponent={Pagination} {...props} />;
    }
    // console.log(data);
    // console.log(paginationModel.page,paginationModel.pageSize);

  return (
    <div className="flex flex-col lg:flex-row w-svw sm:w-[calc(100vw-150px)] h-[calc(100vh-120px)] overflow-y-auto min-w-96 p-2 pt-0 gap-2">

        {/* <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
                <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell>InvNo</TableCell>
                        <TableCell align="center">Date</TableCell>
                        <TableCell align="center">Cashier</TableCell>
                        <TableCell align="center">Customer</TableCell>
                        <TableCell align="center">PaidType</TableCell>
                        <TableCell align="right">Amount&nbsp;($)</TableCell>
                        <TableCell align="right">Discount&nbsp;($)</TableCell>
                        <TableCell align="right">Vat&nbsp;($)</TableCell>
                        <TableCell align="right">Total&nbsp;($)</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {data?.map((row) => (
                    <Row key={row.InvNo} row={row} />
                ))}
                </TableBody>
            </Table>
        </TableContainer> */}
        {/* <div className="h-80 "> */}
        <div className="flex flex-col lg:w-2/3 w-full h-96 lg:h-[calc(100vh-160px)]">
            <span>
                Invoices
                {/* <button
                        type="button"
                        disabled={inv.total? false : true}
                        onClick={handlePrintClick}
                >
                    <PrinterIcon 
                        className={classNames(inv.total? "text-sky-700 cursor-pointer hover:text-sky-500" : "text-gray-500" , "inline-block h-6 w-6 ml-4")} 
                    />
                </button> */}
                <button onClick={() => setIsComponentVisible(true)} disabled={inv.total? false : true}>
                    <PrinterIcon 
                        className={classNames(inv.total? "text-sky-700 cursor-pointer hover:text-sky-500" : "text-gray-500" , "inline-block h-6 w-6 ml-4")} 
                    />
                </button>
             </span>
            {data && 
            <DataGrid 
                checkboxSelection={false} 
                rows={data} 
                rowCount={totalRow}
                columns={columns} 
                density='compact'
                disableRowSelectionOnClick
                // page={page}
                // autoPageSize
                // pageSize={itemsPage}
                // rowsPerPageOptions={[5,10,30,50,100]}
                pageSizeOptions={[5, 10, 25,30, 50, 100, { value: -1, label: 'All' }]}
                pagination
                slots={{
                    pagination: CustomPagination,
                    toolbar:  GridToolbarQuickFilter,
                }}
                // slots={{ toolbar:  GridToolbarQuickFilter 
                //             // GridToolbarFilterButton,
                        
                //     }}
                paginationMode="server"
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                onRowCountChange ={setRowCount}
                // initialState={{
                //     pagination: {
                //     paginationModel: { pageSize: 25, page: 0 },
                //     },
                // }}
                // onRowCountChange={setRowCount}
                // onPageChange={(newPage) => setPage(newPage)}
                // onPageChange={handlePageChange}
                // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                // onPageSizeChange={handlePageSizeChange}
                // filterMode="server"
                // onFilterModelChange={onFilterChange}
                // disableSelectionOnClick
                getRowId={(row) => row.InvNo}
                // onCellEditCommit={(params) => setRowId(params.id)}
                // processRowUpdate={(updatedRow, originalRow) => {
                // console.log(updatedRow);
                // console.log(originalRow);
                // getObjectChanges(originalRow, updatedRow)
                // return updatedRow;
                // setRowId(params.id)
                // }}
                onCellClick={handleCellClick}
                headerHeight={38}
                // components={{
                //         Toolbar: CustomToolbar,
                //         // Pagination: CustomPagination,
                //     // BaseCheckbox: CustomCheck,
                // }}
                // componentsProps={{
                //   toolbar: {
                //     showQuickFilter: true,
                //     quickFilterProps: { debounceMs: 1000},
                //   },
                // }}
                sx={{ 
                    // m:2,
                    [`& .${gridClasses.row}`]: {
                        bgcolor: '#f1e9e9',
                        // bgcolor: (theme) =>
                        // theme.palette.mode === 'light' ? grey[300] : grey[900],
                    },
                    [`& .${gridClasses.columnHeader}`] : {
                        bgcolor: '#0e0e7b',
                        color: '#ffffff',
                        textoverflow: '',
                        // bgcolor: (theme) =>
                        //   theme.palette.mode === 'light' ? grey[500] : blue[800],
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                        whiteSpace: "normal",
                        lineHeight: "normal"
                    },
                    [`& .${gridClasses.footerContainer}`] : {
                        bgcolor: '#0a55b1',
                        // color: '#ffffff',
                    },
                    "& .MuiDataGrid-row:hover": {
                        backgroundColor: "skyblue"
                        // color: "red"
                    },
                    "& .MuiDataGrid-row.Mui-selected": {
                        bgcolor: '#0e6496',
                        color: '#ffffff',
                        '&:hover': {
                            bgcolor: '#1593c4',
                        },
                    },
                    "& .MuiSvgIcon-root": {
                        fill: "#9e9a9a",
                    },
                    "& .MuiInputBase-input.MuiInput-input": {
                        color: "#9e9a9a",
                    },
                    "& .MuiTablePagination-root": {
                        color: "#9e9a9a",
                    },
                    // [`& .${gridClasses.GridToolbarExport}`] : {
                    //   color: (theme) =>
                    //     theme.palette.mode === 'light' ? grey[200] : grey[700],
                    // },

                }}
                // getRowClassName={(params) => `super-app-theme--${params.row.status}`}
                loading={loading}
                // className="bg-gray-600 bg-gray-600"
            />
            }
        </div>
        {/* <div className=" pt-4">
            <span>Detail</span>
            {detail && 
                <DataGrid
                    rows={detail}
                    columns={columnsDetail}
                    density='compact'
                    pagination
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                    loading={loading2}
                    getRowId={(row) => row.InvNo+row.ItemNo}
                    sx={{ 
                        // m:2,
                        [`& .${gridClasses.row}`]: {
                            bgcolor: '#f1e9e9',
                            // bgcolor: (theme) =>
                            // theme.palette.mode === 'light' ? grey[300] : grey[900],
                        },
                        [`& .${gridClasses.columnHeader}`] : {
                            bgcolor: '#0e0e7b',
                            color: '#ffffff',
                            // bgcolor: (theme) =>
                            //   theme.palette.mode === 'light' ? grey[500] : blue[800],
                        },
                        [`& .${gridClasses.footerContainer}`] : {
                            bgcolor: '#0a55b1',
                            color: '#ffffff',
                        },
                        "& .MuiDataGrid-row:hover": {
                            bgcolor: "skyblue"
                            // color: "red"
                        },
                        "& .MuiDataGrid-row.Mui-selected": {
                            bgcolor: '#0e6496',
                            color: '#ffffff',
                            '&:hover': {
                                bgcolor: '#1593c4',
                            },
                        },
                        // [`& .${gridClasses.GridToolbarExport}`] : {
                        //   color: (theme) =>
                        //     theme.palette.mode === 'light' ? grey[200] : grey[700],
                        // },

                    }}
                />
            }
        </div>   */}
      {detail && (

        <div className="flex flex-col w-full lg:w-1/3 xl:1/4 bg-white text-black">
            <div className="flex flex-col p-1 justify-center">

                <div id="print" className="print:hidden printView flex flex-col justify-center text-xs bg-white text-black">
                    <div className="flex flex-col items-center justify-center mt-2 text-lg font-bold">
                            {/* <img src="/logo-720b.png" alt="Online Market" className="w-48" /> */}
                            <p>Molthana Bakery.</p>
                            <p className="text-xs">โทร: 035-559779 , Line ID: 0869863509.</p>
                        </div>
                    <div className="flex justify-center text-sm font-bold ">
                        <span>Invoice</span>
                    </div>
                    <div className="flex justify-between px-4">
                        <div>
                            <span className="font-bold">Date:</span>
                            {/* <span className="ml-4">{(new Date()).toISOString().split('T')[0]}</span> */}
                            <span className="ml-4">{inv?.date}</span>
                        </div>
                        <div>
                            <span className="font-bold">Invoice:</span>
                            <span className="ml-4">#{inv?.InvNo}</span>
                        </div>
                    </div>
                    <div className="flex justify-between px-4">
                        <div>
                            <span className="font-bold">Customer:</span>
                            <span className="ml-4">{inv?.customer_id}</span>
                        </div>
                        <div>
                            <span className="font-bold">Cashier:</span>
                            <span className="ml-4">{inv?.cashier}</span>
                        </div>
                    </div>

                    <div className="flex flex-col  p-2 justify-center">
                        <table className="w-full table-auto ">
                            <caption className="caption-bottom items-center py-8 justify-center font-bold">
                                {/* <div className="flex items-center justify-center text-xl font-bold"> */}
                                        *** ขอบคุณที่ใช้บริการ ***
                                    {/* </div> */}
                            </caption>  
                            <thead>
                                <tr className="border border-slate-300 p-2">
                                <th >Item</th>
                                <th >Qty</th>
                                <th >Unit/Price</th>
                                <th >Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {detail?.map((product,item) => (
                                    <tr key={item} >
                                    <td className="pl-2">{`${product.ItemNo}. ${product.prodName}`}</td>
                                    <td className="text-center">{product.qty}</td>
                                    <td className="text-right pr-2">{product.price}</td>
                                    <td className="text-right pr-2"> {product.price*product.qty}</td>
                                    </tr>
                                ))}
                                <tr key="Subtotal" className="border-t-2">
                                    <td rowSpan="4" className="border-0 items-center justify-center" >
                                        <div className="flex justify-center">
                                            <img src="/qrcodeMD.png" alt="Molthana Bakery" className="w-full max-w-24 overflow-hidden" />
                                            <img src="/qrfacebook.png" alt="FB Molthana Bakery" className="w-full max-w-24 overflow-hidden" />
                                        </div>
                                    </td>
                                    <td className=" text-left border-b-2 pl-2 border-slate-300">Subtotal</td>
                                    <td className=" text-right pr-2 border-b-2 border-slate-300"></td>
                                    <td className="text-right pr-2 border-b-2 border-slate-300">{inv?.subtotal}</td>
                                </tr>
                                <tr key="discount" className="">
                                    {/* <td className=" text-left  border-b-2 border-slate-300"></td> */}
                                    <td className=" text-left pl-2 border-b-2 border-slate-300">
                                        Discount
                                    </td>
                                    <td className=" text-right pr-2 border-b-2 border-slate-300"></td>
                                    <td className="text-right pr-2 border-b-2 border-slate-300">{inv?.discount}</td>
                                </tr>
                                <tr key="vat" className="">
                                    {/* <td></td> */}
                                    <td className=" text-left border-b-2 pl-2 border-slate-300">Vat</td>
                                    <td className=" text-right pr-2  border-b-2 border-slate-300"></td>
                                    <td className="text-right pr-2  border-b-2 border-slate-300">{inv?.vat}</td>
                                </tr>
                                <tr key="total" className=" ">
                                    {/* <td ></td> */}
                                    <td className=" text-left border-b-2 pl-2 border-slate-300">Total</td>
                                    <td className=" text-right pr-2 border-b-2 border-slate-300">"{inv?.paidtype}"</td>
                                    <td className="text-right pr-2 font-bold  border-b-2 border-slate-300">{numberWithCommas(inv?.total)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>

            {/* *** for print *** */}
            <div ref={ref}>
                {isComponentVisible && (
                <div className="absolute inset-0 z-50 flex flex-col p-0 bg-slate-500">
                    <div id="print" className="printView flex flex-col  w-full mx-auto justify-center text-xs bg-white text-black">
                        <div className="flex flex-col items-center justify-center mt-1 text-lg font-bold">
                            {/* <img src="/logo-720b.png" alt="Online Market" className="w-48" /> */}
                            <p>Molthana Bakery.</p>
                            <p className="text-xs">โทร: 035-559779 , Line ID: 0869863509.</p>
                        </div>
                        <div className="flex justify-center text-sm font-bold ">
                            <span>Invoice</span>
                        </div>
                        <div className="flex justify-between px-4">
                            <div>
                                <span className="font-bold">Date:</span>
                                {/* <span className="ml-4">{(new Date()).toISOString().split('T')[0]}</span> */}
                                <span className="ml-4">{inv?.date}</span>
                            </div>
                            <div>
                                <span className="font-bold">Invoice:</span>
                                <span className="ml-4">#{inv?.InvNo}</span>
                            </div>
                        </div>
                        <div className="flex justify-between px-4">
                            <div>
                                <span className="font-bold">Customer:</span>
                                <span className="ml-4">{inv?.customer_id}</span>
                            </div>
                            <div>
                                <span className="font-bold">Cashier:</span>
                                <span className="ml-4">{inv?.cashier}</span>
                            </div>
                        </div>

                        <div className="flex flex-col  p-2 justify-center">
                            <table className="w-full table-auto ">
                                <caption className="caption-bottom items-center py-4 text-sm justify-center font-bold">
                                    {/* <div className="flex items-center justify-center text-xl font-bold"> */}
                                        *** ขอบคุณที่ใช้บริการ ***
                                    {/* </div> */}
                                </caption>  
                                <thead>
                                    <tr className="border border-slate-300 p-2">
                                    <th>Item</th>
                                    <th className="">Qty</th>
                                    <th className="text-right">Unit/Price</th>
                                    <th className="text-right pr-2">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {detail?.map((product,item) => (
                                        <tr key={item} >
                                        <td className="pl-2">{`${product.ItemNo}. ${product.prodName}`}</td>
                                        <td className="text-center ">{product.qty}</td>
                                        <td className="text-right pr-2 ">{product.price}฿</td>
                                        <td className="text-right pr-2 "> {product.price*product.qty}฿</td>
                                        </tr>
                                    ))}
                                    <tr key="Subtotal" className="border-t-2 ">
                                        <td rowSpan="4" className="border-0 items-center justify-center" >
                                            <div className="flex flex-col sm:flex-row justify-center">
                                               <img src="/qrcodeMD.png" alt="Molthana Bakery" className="w-full max-w-48 overflow-hidden" />
                                               <img src="/qrfacebook.png" alt="FB Molthana Bakery" className="w-full max-w-48 overflow-hidden" />
                                            </div>
                                        </td>
                                        <td className=" text-left border-b-2 pl-2 border-slate-300">Subtotal</td>
                                        <td className=" text-right pr-2  border-b-2 border-slate-300"></td>
                                        <td className="text-right pr-2  border-b-2 border-slate-300">{inv?.subtotal}฿</td>
                                    </tr>
                                    <tr key="discount" className="">
                                        {/* <td className=" text-left  border-b-2 border-slate-300"></td> */}
                                        <td className=" text-left pl-2 border-b-2 border-slate-300">
                                            Discount
                                        </td>
                                        <td className=" text-right pr-2  border-b-2 border-slate-300"></td>
                                        <td className="text-right pr-2  border-b-2 border-slate-300">{inv?.discount}฿</td>
                                    </tr>
                                    <tr key="vat" className="">
                                        {/* <td></td> */}
                                        <td className=" text-left  border-b-2 pl-2 border-slate-300">Vat</td>
                                        <td className=" text-right pr-2  border-b-2 border-slate-300"></td>
                                        <td className="text-right pr-2  border-b-2 border-slate-300">{inv?.vat}฿</td>
                                    </tr>
                                    <tr key="total" className=" ">
                                        {/* <td ></td> */}
                                        <td className=" text-left border-b-2 pl-2 border-slate-300">Total</td>
                                        <td className=" text-right pr-2  border-b-2 border-slate-300">"{inv?.paidtype}"</td>
                                        <td className="text-right pr-2 text-lg font-bold  border-b-2 border-slate-300">{numberWithCommas(inv?.total)}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="flex gap-4 mt-4 mx-auto">
                                <button onClick={() => window.print()} className="print:hidden rounded-xl text-white bg-blue-700 p-2 hover:bg-blue-500" >Print </button>
                                <button onClick={() => setIsComponentVisible(false)} className="print:hidden rounded-xl text-white bg-red-700 p-2 hover:bg-red-500" >Close </button>
                            </div>
                        </div>
                    </div>
                </div>  
                )}
            </div>
            {/* End for print */}

        </div>
        )}

    </div>
  )
}

